
import { BodyXS, Box, Tooltip } from '@parspec/pixel';


const TAB_DISABLED_TOOLTIP = 'Save branch details first'

export const DisabledTab = ({ tabName }: { tabName: string }) => {

    return (
        <Box>
            <Tooltip placement="bottom" title={TAB_DISABLED_TOOLTIP}>
                <Box display="flex" alignItems="center" gap="4px">
                    <BodyXS color="neutral.main" fontWeight="500">
                        {tabName}
                    </BodyXS>
                </Box>
            </Tooltip>
        </Box>
    );
};
